/* eslint-disable import/prefer-default-export */
import gql from 'graphql-tag';

export const CREATE_DISTRIBUTION_COUNT = gql`
  mutation CreateDistributionCount($input: CreateDistributionCountInput!) {
    createDistributionCount(createDistributionCountInput: $input) {
      id
      suburbName
      total
      publication {
        id
      }
    }
  }
`;

export const CREATE_SALES_POINT = gql`
  mutation CreateSalesPoint($input: CreateSalesPointInput!) {
    createSalesPoint(input: $input) {
      id
      name
      publications {
        id
      }
    }
  }
`;

export const CREATE_SALES_POINTS_BULK = gql`
  mutation CreateSalesPointsBulk($file: Upload!, $pointCategorizationId: Int!, $approvalStatus: String!) {
    createSalesPointsBulk(file: $file, pointCategorizationId: $pointCategorizationId, approvalStatus: $approvalStatus)
  }
`;

export const DELETE_DISTRIBUTION_COUNT = gql`
  mutation DeleteDistributionCount($deleteDistributionCountInput: DeleteDistributionCountInput!) {
    deleteDistributionCount(deleteDistributionCountInput: $deleteDistributionCountInput)
  }
`;

export const TOGGLE_POINT_STATUS = gql`
  mutation togglePointStatus($id: Int!, $isDisabled: Boolean!) {
    updateSalesPointDisabledStatus(id: $id, isDisabled: $isDisabled) {
      id
      name
      publications {
        id
      }
    }
  }
`;

export const UPDATE_DISTRIBUTION_COUNT = gql`
  mutation UpdateDistributionCount($input: UpdateDistributionCountInput!) {
    updateDistributionCount(updateDistributionCountInput: $input) {
      id
      suburbName
      total
      publication {
        id
      }
    }
  }
`;

export const UPDATE_SALESPOINT = gql`
  mutation UpdateSalesPoint($salespoint: UpdateSalesPointInput!) {
    updateSalesPoint(input: $salespoint) {
      id
      name
      publications {
        id
      }
    }
  }
`;
